import { STATICINFOS_SERVICE } from "@/services/staticInfos.service.js";

const state = {getStaticInfosOutput: {}, postStaticInfoOutput: false, putStaticInfoOutput: false, putStaticInfoStatusOutput: false, getStaticInfoDetailsOutput: {}};

const actions = {
    //Service to get static infos
    getStaticInfos({ dispatch, commit }, queryParams) {
        dispatch('alert/clear', null, { root: true });
        commit('getStaticInfosRequest');

        STATICINFOS_SERVICE.getStaticInfos(queryParams)
            .then(
                output => {
                    commit('getStaticInfosSuccess', output);
                },
                error => {
                    commit('getStaticInfosFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to create static infos
    postStaticInfo({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('postStaticInfoRequest');

        STATICINFOS_SERVICE.postStaticInfo(input)
            .then(
                output => {
                    commit('postStaticInfoSuccess', output);
                },
                error => {
                    commit('postStaticInfoFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to update static info
    putStaticInfo({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('putStaticInfoRequest');

        STATICINFOS_SERVICE.putStaticInfo(input)
            .then(
                output => {
                    commit('putStaticInfoSuccess', output);
                },
                error => {
                    commit('putStaticInfoFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to update status
    putStaticInfoStatus({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('putStaticInfoStatusRequest');

        STATICINFOS_SERVICE.putStaticInfoStatus(input)
            .then(
                output => {
                    commit('putStaticInfoStatusSuccess', output);
                },
                error => {
                    commit('putStaticInfoStatusFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to get static info details
    getStaticInfoDetails({ dispatch, commit }, uniqueIdentifier) {
        dispatch('alert/clear', null, { root: true });
        commit('getStaticInfoDetailsRequest');

        STATICINFOS_SERVICE.getStaticInfoDetails(uniqueIdentifier)
            .then(
                output => {
                    commit('getStaticInfoDetailsSuccess', output);
                },
                error => {
                    commit('getStaticInfoDetailsFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
};

const mutations = {
    //getStaticInfos
    getStaticInfosRequest(state) {
    },
    getStaticInfosSuccess(state, output) {
        state.getStaticInfosOutput = output;
    },
    getStaticInfosFailure(state) {
        state.getStaticInfosOutput = false;
    },

    //postStaticInfo
    postStaticInfoRequest(state) {
        state.postStaticInfoOutput = null;
    },
    postStaticInfoSuccess(state, output) {
        state.postStaticInfoOutput = output;
    },
    postStaticInfoFailure(state) {
        state.postStaticInfoOutput = false;
    },

    //putStaticInfo
    putStaticInfoRequest(state) {
        state.putStaticInfoOutput = null;
    },
    putStaticInfoSuccess(state, output) {
        state.putStaticInfoOutput = true;
    },
    putStaticInfoFailure(state) {
        state.putStaticInfoOutput = false;
    },

    //putStaticInfoStatus
    putStaticInfoStatusRequest(state) {
        state.putStaticInfoStatusOutput = null;
    },
    putStaticInfoStatusSuccess(state, output) {
        state.putStaticInfoStatusOutput = true;
    },
    putStaticInfoStatusFailure(state) {
        state.putStaticInfoStatusOutput = false;
    },

    //getStaticInfoDetails
    getStaticInfoDetailsRequest(state) {
    },
    getStaticInfoDetailsSuccess(state, output) {
        state.getStaticInfoDetailsOutput = output;
    },
    getStaticInfoDetailsFailure(state) {
        state.getStaticInfoDetailsOutput = false;
    },
};

export const staticInfos = {
    namespaced: true,
    state,
    actions,
    mutations
};